// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"374":"3e510041","457":"45b5732b","766":"6e6f8b27","866":"45b5732b"}[chunkId] + ".chunk.css";
};